// import Vue from 'vue'
// import { t } from '../locale'

export const TableTypeOptions = [

]

export const STORAGE_NAMESPACE = 'oecp-meta-data_'
